import { Component, OnInit } from "@angular/core";

import { MessageService } from "../services/message.service";

@Component({
    selector: "alert",
    templateUrl: "./alert.component.html",
    styleUrls: ["./alert.component.scss"],
    standalone: false
})

export class AlertComponent implements OnInit {
    showAlert: boolean = false;
    message: string = "";

    constructor( public messageService: MessageService ) {}

    ngOnInit() {
        this.getMessage();
    }

    getMessage(): void {
        this.messageService.getMessage().subscribe(result => {
            this.message = result.curMessage;
            this.updateAlert();
        });
    }

    updateAlert(): void {
        this.showAlert = true;

        //close alert after 3 seconds
        setTimeout(() => {
            this.showAlert = false;
        }, 3000)
    }

    close(): void {
        this.showAlert = false;
    }
}